const INITIAL_STATE = {
  esperandoRespostaSolicitacao: false,
  mensagem: "",
  mensagemSecundaria: "",
  cpf: "",
  gRecaptchaResponse: ""
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    //ATUALIZACAO DE INFORMACAO
    case "REVISAO_CPF_ATUALIZADO":
    return {
        ...state,
        esperandoRespostaSolicitacao: false,
        cpf: action.payload,
        mensagem: "",
        mensagemSecundaria: "",
      };
    case "REVISAO_RECAPTCHA_RESPONSE_ATUALIZADO":
      return {
        ...state,
        esperandoRespostaSolicitacao: false,
        gRecaptchaResponse: action.payload,
      };
    case "RESET_RECAPTCHA_RESPONSE":
      return {
        ...state,
        gRecaptchaResponse: "",
      };

    //ACOES DE IMPRESSAO
    case "REVISAO_CONSULTA_SOLICITADA":
      return { ...state, esperandoRespostaSolicitacao: true };
    case "REVISAO_CONSULTA_RECEBIDA":
    return { ...state, 
        esperandoRespostaSolicitacao: false,
        mensagem: action.payload.mensagem,
        mensagemSecundaria: action.payload.mensagemSecundaria 
      };
    case "REVISAO_ERRO_RECEBIDO":
    return {
        ...state,
        esperandoRespostaSolicitacao: false,
        mensagem: action.payload.mensagem,
        mensagemSecundaria: action.payload.mensagemSecundaria 
      };

    default:
      return state;
  }
};
